<template>
  <div>
    <h1>Lista de planos</h1>
    <b-card no-body>
      <div class="d-flex mb-2 pt-4 px-4 pb-3">
        <div class="w-75 mr-auto">
          <b-input-group class="search-field-list">
            <b-form-input
              v-model="termo_pesquisa"
              v-on:keyup.enter="searchTerm"
              placeholder="Pesquisar"
              class="search-field"
            />
            <b-input-group-append v-if="displayReset">
              <b-button @click="reset" variant="outline-danger">
                <font-awesome-icon icon="close" />
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button @click="searchTerm" variant="exitos">
                <font-awesome-icon icon="magnifying-glass" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div>
          <b-button
            v-if="$can('plano:create')"
            variant="exitos"
            :to="{ name: 'planos_create' }"
          >
            <font-awesome-icon icon="plus" />
            Novo
          </b-button>
        </div>
      </div>

      <b-table
        hover
        :items="planos"
        :fields="fields"
        :busy="isBusy"
        @sort-changed="sortingChanged"
        show-empty
        sort-icon-left
      >
        <template #cell(nome)="{ value, item }">
          <span>
            <h5 class="font-weight-500 mb-0 d-inline" v-text="value" />
            <b-badge
              v-if="item.venda_online"
              pill
              class="bg-success-dark bg-success-dark-10 text-success-dark d-inline ml-1"
            >
              <font-awesome-icon icon="circle-check" />
              Venda online
            </b-badge>
          </span>
        </template>
        <template #cell(visivel)="{ value }">
          <span>
            <font-awesome-icon v-if="!!value" :icon="value" color="green" />
          </span>
        </template>
        <template #cell(valor)="{ value }">
          <div
            class="mb-0"
            :class="
              value.isZero
                ? 'text-gray-dark font-weight-500'
                : 'text-success-dark font-weight-600'
            "
            v-text="value.value"
          />
        </template>
        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :view_edit="$can('plano:edit')"
            :view_delete="$can('plano:delete')"
            edit_to="planos_edit"
            @delete="deleteItem"
          />
        </template>

        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </b-card>

    <div>
      <pagination-nav :pagination="pagination" @input="loadData()" />
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";
import { useActions, useNamespacedState } from "vuex-composition-helpers";
import Actions from "@/components/Table/Actions.vue";
import { useTableList } from "@/composables/useTableList";
import numberFormat from "@/helpers/filters/number_format";
import { numberToBoolean } from "@/helpers/functions/numericBoolean";

export default defineComponent({
  name: "PlanosList",
  components: {
    Actions,
  },
  setup() {
    const { planos, pagination } = useNamespacedState("planos", [
      "planos",
      "pagination",
    ]);
    const { ActionGetAll, ActionDelete, ActionSetPagination } = useActions(
      "planos",
      ["ActionGetAll", "ActionDelete", "ActionSetPagination"]
    );

    const table = useTableList({
      pagination,
      fetchItems: ActionGetAll,
      removeItem: ActionDelete,
      setPagination: ActionSetPagination,
    });

    const fields = computed(() => [
      {
        key: "id",
        label: "COD",
        class: "col-1",
        sortable: true,
        formatter: (value) => `#${value}`,
      },
      {
        key: "nome",
        label: "Nome",
        class: "col-8",
        sortable: true,
      },
      {
        key: "valor",
        label: "Valor base",
        class: "col-1",
        sortable: true,
        formatter: (value) => ({
          value: `R$ ${numberFormat(value)}`,
          isZero: !(value > 0),
        }),
      },
      {
        key: "visivel",
        label: "Ativo",
        sortable: true,
        class: "text-center col-1",
        formatter: (value) => (numberToBoolean(value) ? "circle-check" : ""),
      },
      { key: "actions", label: "", class: "cell-actions" },
    ]);

    return {
      planos,
      pagination,
      fields,
      ...table,
    };
  },
});
</script>

<style></style>
